import { Button } from "components/common/Button";
import { Input } from "components/common/Input";
import { ReactElement } from "react";

export function ModalDelete(props: {
  visible: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  deleteAction: () => void;
}): ReactElement {
  const { visible, setShowModal, deleteAction } = props;

  return (
    <div
      className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col space-y-8 px-8 py-4 w-96 bg-white border-2 border-gray-300 shadow-2xl ${
        visible ? "visible" : "hidden"
      }`}
    >
      <div className="flex flex-row space-x-4 items-center">
        <div className="flex flex-col items-center justify-center w-12 h-12 rounded-full bg-red-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6 self-center text-red-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <p className="font-bold">Löschen</p>
      </div>
      <p>
        Wollen Sie die Kennwerte wirklich löschen? Dieser Vorgang kann nicht
        rückgängig gemacht werden.
      </p>
      <div className="flex flex-row items-center justify-end space-x-4">
        <span
          className="cursor-pointer text-red-400"
          onClick={() => {
            setShowModal(false);
          }}
        >
          Abbrechen
        </span>
        <Button
          className="bg-red-400"
          onClick={() => {
            deleteAction();
            setShowModal(false);
          }}
        >
          Löschen
        </Button>
      </div>
    </div>
  );
}
